import type { ProjektMerkmale } from '../types';

/**
 * Die drei Merkmalsgruppen der Erfassungsmaske. Reihenfolge ist bewusst die
 * des Bauablaufs und nicht alphabetisch — so hakt man sie beim Lesen der
 * Baubeschreibung von oben nach unten ab.
 *
 * Eigene Datei ohne React, weil neben der Maske auch der Leitfaden
 * (`leitfaden.ts`, Station „Merkmale") zaehlt, wie viele davon noch offen
 * sind — beide muessen dieselbe Liste meinen.
 */
export const MERKMAL_GRUPPEN: ReadonlyArray<{ titel: string; keys: ReadonlyArray<keyof ProjektMerkmale> }> = [
    {
        titel: 'Bauaufgabe',
        keys: ['bestand', 'abbruch', 'erdarbeiten', 'altlastenverdacht', 'betriebLaeuftWeiter', 'strassenbaustelle'],
    },
    {
        titel: 'Verfahren und Geräte',
        keys: ['fertigteilmontage', 'kran', 'geruest', 'ortbeton', 'dacharbeiten', 'tga', 'nachtarbeit', 'winterbau'],
    },
    {
        titel: 'Besonders gefährliche Arbeiten (Anhang II BaustellV)',
        keys: ['freileitung', 'gewaesser', 'tunnelbau', 'taucharbeiten', 'druckluft', 'sprengarbeiten', 'strahlung', 'gefahrstoffeAnhang2'],
    },
];

/** Alle Ja/Nein-Merkmale der Maske in Anzeigereihenfolge. */
export const MERKMAL_SCHLUESSEL: ReadonlyArray<keyof ProjektMerkmale> = MERKMAL_GRUPPEN.flatMap(g => g.keys);
